import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export type TEnergyManagement = {
  batteryChargeDischargePower: {
    battery_charge: number;
    battery_discharge: number;
    time: string;
  }[];
  batterySoC: {
    battery_state_of_charge: number;
    time: string;
  }[];
};

export async function getChartBESSQuery({
  id,
}: {
  id: string | undefined;
}): Promise<TEnergyManagement | undefined | never> {
  if (!id) return undefined;

  try {
    const { data } = await client.get<{ body: TEnergyManagement | undefined }>(
      `/bess/${id}/charts`
    );

    return data.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useGetChartBESSQuery = ({
  id,
  enabled = true,
}: {
  id: string | undefined;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ['bess', id, 'charts'],
    queryFn: () => getChartBESSQuery({ id }),
    retry: 1,
    staleTime: 1000 * 60 * 5,
    enabled,
  });
};
